import React from "react";
import ClientHeader from "../../Share/ClientHeader";
import { Outlet } from "react-router-dom";
import ClientFooter from "../../Share/ClientFooter";
import logo18 from "../../Css/img_news/logo_18.png";
import Styles from "./ClientPage.module.scss";
function ClientPage(){

    return(
        <div>
            <img
                className={Styles.ageLogo}
                src={logo18}
                alt="Game danh cho nguoi tren 18 tuoi"
            />
            <ClientHeader/>         
            {/* <PhoneReverificationModal/> */}
            <Outlet/>
            {/* <Messenger/> */}
           <ClientFooter/>
            
        </div>
    )
}

export default  ClientPage
